import React from "react";

import OrganizationAppDataForm from "./OrganizationAppDataForm";

export default function OrganizationDetail(props: {
  organization: IOrganization;
}): React.JSX.Element {
  /**
   * A detailed view of an organization.
   */
  const organization = props.organization;
  return (
    <div>
      <ul className="m-0 ps-3">
        <li>
          <strong>Naam:</strong>
          {" " + organization.name}
        </li>
        {organization.websiteDomain ? (
          <li>
            <strong>Website:</strong>{" "}
            <a
              href={`http://${organization.websiteDomain}`}
              target="_blank"
              referrerPolicy="no-referrer"
              rel="noreferrer"
            >
              {organization.websiteDomain}
            </a>
          </li>
        ) : (
          <></>
        )}
        {organization.bedrijfsdata.map((bedrijfsdata) => (
          <React.Fragment key={`bedrijfsdata-${bedrijfsdata.id}`}>
            {organization.bedrijfsdata.length > 1 && (
              <>
                <hr />
                {bedrijfsdata.name ? (
                  <li>
                    <strong>Vestigingsnaam:</strong>
                    {" " + bedrijfsdata.name}
                  </li>
                ) : (
                  <></>
                )}
              </>
            )}
            {bedrijfsdata.kvkNumber ? (
              <li>
                <strong>KVK-nummer:</strong>
                {" " + bedrijfsdata.kvkNumber}
              </li>
            ) : (
              <></>
            )}
            {bedrijfsdata.phoneNumber ? (
              <li>
                {organization.googlePlaces.length > 0 ? (
                  <strong>Telefoonnummer (bron: Bedrijfsdata):</strong>
                ) : (
                  <strong>Telefoonnummer:</strong>
                )}
                {" " + bedrijfsdata.phoneNumber}
              </li>
            ) : (
              <></>
            )}
            {bedrijfsdata.email ? (
              <li>
                <div className="text-truncate">
                  <strong>E-mailadres:</strong>{" "}
                  <a
                    href={`mailto:${bedrijfsdata.email}`}
                    target="_blank"
                    referrerPolicy="no-referrer"
                    rel="noreferrer"
                  >
                    {bedrijfsdata.email}
                  </a>
                </div>
              </li>
            ) : (
              <></>
            )}
            {bedrijfsdata.foundationYear ? (
              <li>
                <strong>Oprichtingsjaar:</strong>
                {" " + bedrijfsdata.foundationYear}
              </li>
            ) : (
              <></>
            )}
            {bedrijfsdata.numberOfEmployees ? (
              <li>
                <strong>Aantal medewerkers (vestiging):</strong>
                {" " + bedrijfsdata.numberOfEmployees}
              </li>
            ) : (
              <></>
            )}
            {bedrijfsdata.organizationType ? (
              <li>
                <strong>Rechtsvorm:</strong>
                {" " + bedrijfsdata.organizationType}
              </li>
            ) : (
              <></>
            )}
            {bedrijfsdata.locationType ? (
              <li>
                <strong>Vestiging:</strong>
                {" " + bedrijfsdata.locationType}
              </li>
            ) : (
              <></>
            )}
            {bedrijfsdata.sbiCodes ? (
              <li>
                <strong>SBI codes:</strong> {bedrijfsdata.sbiCodes.join(", ")}
              </li>
            ) : (
              <></>
            )}
            {bedrijfsdata.kvkBranches ? (
              <li className="text-wrap">
                <strong>Branches:</strong> {bedrijfsdata.kvkBranches.join(", ")}
              </li>
            ) : (
              <></>
            )}
            <li>
              {organization.googlePlaces.length > 0 ? (
                <strong>Bekijk in (bron: Bedrijfsdata):</strong>
              ) : (
                <strong>Bekijk in:</strong>
              )}
              <ul>
                {bedrijfsdata.kvkNumber ? (
                  <li>
                    <a
                      href={`https://companyinfo.nl/freemium?q=${bedrijfsdata.kvkNumber}`}
                      target="_blank"
                      referrerPolicy="no-referrer"
                      rel="noreferrer"
                    >
                      Company.info
                    </a>
                  </li>
                ) : (
                  <></>
                )}
                {bedrijfsdata.linkedinLink ? (
                  <li>
                    <a
                      href={bedrijfsdata.linkedinLink}
                      target="_blank"
                      referrerPolicy="no-referrer"
                      rel="noreferrer"
                    >
                      LinkedIn
                    </a>
                  </li>
                ) : (
                  <></>
                )}
                {bedrijfsdata.facebookLink ? (
                  <li>
                    <a
                      href={bedrijfsdata.facebookLink}
                      target="_blank"
                      referrerPolicy="no-referrer"
                      rel="noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                ) : (
                  <></>
                )}
                {bedrijfsdata.youtubeLink ? (
                  <li>
                    <a
                      href={bedrijfsdata.youtubeLink}
                      target="_blank"
                      referrerPolicy="no-referrer"
                      rel="noreferrer"
                    >
                      YouTube
                    </a>
                  </li>
                ) : (
                  <></>
                )}
                {bedrijfsdata.instagramLink ? (
                  <li>
                    <a
                      href={bedrijfsdata.instagramLink}
                      target="_blank"
                      referrerPolicy="no-referrer"
                      rel="noreferrer"
                    >
                      Instagram
                    </a>
                  </li>
                ) : (
                  <></>
                )}
                {bedrijfsdata.pinterestLink ? (
                  <li>
                    <a
                      href={bedrijfsdata.pinterestLink}
                      target="_blank"
                      referrerPolicy="no-referrer"
                      rel="noreferrer"
                    >
                      Pinterest
                    </a>
                  </li>
                ) : (
                  <></>
                )}
              </ul>
            </li>
          </React.Fragment>
        ))}
        {organization.googlePlaces.map((googlePlace) => (
          <React.Fragment key={`google-place-${googlePlace.id}`}>
            {organization.googlePlaces.length > 1 && (
              <>
                <hr />
                {googlePlace.name ? (
                  <li>
                    <strong>Vestigingsnaam:</strong>
                    {" " + googlePlace.name}
                  </li>
                ) : (
                  <></>
                )}
              </>
            )}
            {googlePlace.phoneNumber ? (
              <li>
                {organization.bedrijfsdata.length > 0 ? (
                  <strong>Telefoonnummer (bron: Google):</strong>
                ) : (
                  <strong>Telefoonnummer:</strong>
                )}
                {" " + googlePlace.phoneNumber}
              </li>
            ) : (
              <></>
            )}
            {googlePlace.id ? (
              <li>
                <div className="text-truncate">
                  {organization.bedrijfsdata.length > 0 ? (
                    <strong>Bekijk in (bron: Google):</strong>
                  ) : (
                    <strong>Bekijk in:</strong>
                  )}
                  <ul>
                    <li>
                      <a
                        href={`https://www.google.com/maps/place/?q=place_id:${googlePlace.id}`}
                        target="_blank"
                        referrerPolicy="no-referrer"
                        rel="noreferrer"
                      >
                        Google Maps
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            ) : (
              <></>
            )}
          </React.Fragment>
        ))}
      </ul>
      <hr />

      <OrganizationAppDataForm organization={organization} />
    </div>
  );
}
